import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import analytics from '../utils/analytics';

class Hero {
	constructor() {
		this.$expandHeroCallout = $('.js-expand-hero-callout');
		this.$expandedContent = $('.js-expanded-content');
        this.$closeExpandedContent = $('.js-close-expanded-content');
        this.$expandedBubble = $('.hero--story-expanded');
		this.$toggleHeroCaption = $('.js-toggle-hero-image-caption');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.$expandHeroCallout.on('click', e => { this.toggleExpandedContent(e); });
        this.$closeExpandedContent.on('click', e => { this.closeExpandedContent(e); });
        this.$expandedBubble.on('click', e => { this.expandedBubbleClick(e); });
		this.$toggleHeroCaption.on('click', e => { this.toggleHeroCaption(e); });
	}

    closeExpandedContent(e) {
        const type = $('.hero--story-callouts-wrap').find('.active').find('p')[0].innerText;
        analytics.expandedStoryCalloutClick(type, 'X', '(not set)');
		this.$expandHeroCallout.removeClass('active');
		$('.hero--story-expanded').removeClass('active');
		$('.hero--story-callouts').removeClass('active');
		$('.hero--story-expanded-content').css('opacity', '0');
		this.$expandedContent.html('');
	}

	toggleExpandedContent(e) {
		const target = $(e.currentTarget);
		const expanded = $(target).closest('.story-callout').find('.story-callout-expanded').html();
        analytics.storyCalloutClick($(target));

		if (!$(target).hasClass('active')) {
			$('.story-callout-expanded').slideUp();

			this.$expandHeroCallout.removeClass('active');
			$(target).addClass('active');

			$('.hero--story-expanded').addClass('active');
			$('.hero--story-callouts').addClass('active');
            this.$expandedContent.html($(expanded));
			setTimeout(() => {
				$('.hero--story-expanded-content').css('opacity', '1');
			}, 800);
		}
		else {
			this.$expandHeroCallout.removeClass('active');
			$(target).removeClass('active');

			$('.hero--story-expanded').removeClass('active');
			$('.hero--story-callouts').removeClass('active');
			this.$expandedContent.html('');
			$('.hero--story-expanded-content').css('opacity', '0');
			$(target).blur();
		}

		$(target).closest('.story-callout').find('.story-callout-expanded').slideToggle();
    }

    expandedBubbleClick(e) {
        const heroExpanded = $('.hero--story-expanded');
        if ($(e.target).hasClass('cta-link')) {
            const type = $('.hero--story-callouts-wrap').find('.active').find('p')[0].innerText;
            const ctaText = $(heroExpanded).find('.cta-link')[0].innerText;
            const ctaUrl = $(heroExpanded).find('.cta-link')[0].href;
            analytics.expandedStoryCalloutClick(type, ctaText, ctaUrl);
        }
    }

    toggleHeroCaption(e) {
		const target = $(e.currentTarget);
		const caption = $(target).closest('#heroImgInfoContainer').find('.captionHide');

		$(target).toggleClass('active');
		$(caption).toggle().toggleClass('active');
    }
}

export default Hero;